import { render } from "./viewFolders.vue?vue&type=template&id=2d66baeb"
import script from "./viewFolders.vue?vue&type=script&lang=js"
export * from "./viewFolders.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__